<template>
  <div class="pt-5">
    <Card>
      <template v-slot:title-panel> Seguimiento </template>

      <v-form ref="seguimientoForm" :lazy-validation="true">
        <v-row class="mt-4" justify="end">
          <v-col cols="auto">
            <v-btn
              v-if="canEdit"
              rounded
              color="#b11f1f"
              dark
              @click="toggleEdit"
              :disabled="loading"
            >
              {{ editMode ? "Cancelar edición" : "Editar" }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="editMode">
          <!-- Asignar a -->
          <v-col cols="12" md="6">
            <v-autocomplete
              label="Asignar a"
              :items="usuariosDisponibles"
              item-text="nombreCompleto"
              item-value="id"
              v-model="seguimientoLocal.asignadoId"
              placeholder="Seleccione un usuario"
              :rules="requiredRule"
              outlined
              color="#b11f1f"
              :readonly="!editMode"
              clearable
              :no-data-text="'No se encontraron usuarios...'"
            />
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" md="6">
            <v-text-field
              label="Asignado a"
              v-model="seguimientoLocal.nombreEjecutivo"
              outlined
              color="#b11f1f"
              readonly
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="Creado por"
              v-model="seguimientoLocal.nombreCreadoPor"
              outlined
              color="#b11f1f"
              readonly
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Fecha creación"
              :value="fechaCreacionDisplay"
              outlined
              color="#b11f1f"
              readonly
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Modificado por"
              v-model="seguimientoLocal.nombreModificadoPor"
              outlined
              color="#b11f1f"
              readonly
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="Fecha última modificación"
              :value="fechaModificacionDisplay"
              color="#b11f1f"
              outlined
              readonly
            />
          </v-col>
        </v-row>

        <v-row class="mt-6" justify="end" v-if="editMode">
          <v-col cols="auto">
            <v-btn
              rounded
              dark
              color="#b11f1f"
              class="ml-2"
              @click="guardarSeguimiento"
              :loading="loading"
              :disabled="loading"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/commondComponents/Card.vue";
import { getAgentesByRoles } from "@/services/agentService.js";
import { updateSolicitud } from "@/services/solicitudService";
export default {
  components: { Card },
  props: {
    mode: { type: String, default: "view" },
    solicitud: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      seguimientoLocal: {},
      usuariosDisponibles: [],
      loading: false,
      currentUser: null,
      editMode: false,
      showActionsComp: true,
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
    };
  },
  computed: {
    canEdit() {
      return ["ADMIN", "SUPERVISOR", "COORDINADOR", "GERENTE"].includes(
        this.rol
      );
    },
    fechaCreacionDisplay() {
      return this.formatearFecha(this.seguimientoLocal.fechaCreacion);
    },
    fechaModificacionDisplay() {
      return this.formatearFecha(this.seguimientoLocal.fechaModificacion);
    },
    requiredRule() {
      return this.editMode ? [(v) => !!v || "Debe asignar un usuario"] : [];
    },
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.initializeSeguimiento(newVal);
        }
      },
    },
  },
  mounted() {
    this.currentUser = this.getCurrentUser();
    this.loadDispAgentes();
    this.initializeSeguimiento(this.solicitud);
  },
  methods: {
    toggleEdit() {
      this.editMode = !this.editMode;
    },
    getCurrentUser() {
      try {
        const roles = JSON.parse(localStorage.getItem("roles"));
        return roles?.[0] || null;
      } catch {
        return null;
      }
    },
    async loadDispAgentes() {
      const roles = ["SUPERVISOR", "OPERADORSERVICIOS"];
      this.usuariosDisponibles = await getAgentesByRoles({ roles });
    },
    initializeSeguimiento(solicitud) {
      this.seguimientoLocal = {
        asignadoId: solicitud.asignadoId || null,
        asignadoNombre: solicitud.asignadoNombre || "",
        nombreCreadoPor: solicitud.nombreCreadoPor || "",
        fechaCreacion: solicitud.fechaCreacion || "",
        nombreModificadoPor: solicitud.nombreModificadoPor || "",
        fechaModificacion: solicitud.fechaModificacion || "",
        nombreEjecutivo: solicitud.nombreEjecutivo || "",
        status: solicitud.statusId,
      };
    },
    formatearFecha(fecha) {
      if (!fecha) return "N/A";
      try {
        const date = new Date(fecha);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch {
        return fecha;
      }
    },

    async guardarSeguimiento() {
      if (!this.$refs.seguimientoForm.validate()) return;
      this.loading = true;
      try {
        const data = { asignadoId: this.seguimientoLocal.asignadoId };
        const res = await updateSolicitud(data, this.solicitud.id);
        if (res.solicitud) {
          this.$toast.success("Seguimiento actualizado correctamente");

          const asignado = this.usuariosDisponibles.find(
            (u) => u.id === this.seguimientoLocal.asignadoId
          );
          if (asignado) {
            this.seguimientoLocal.nombreEjecutivo = asignado.nombreCompleto;
          }
          setTimeout(() => {
            location.reload();
          }, 2000);
        } else {
          this.$toast.error("Error al guardar el seguimiento");
        }
        this.editMode = false;
      } catch (error) {
        console.error("Error al guardar seguimiento:", error);
        this.$toast.error("Error al guardar el seguimiento");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
